"use client";

import ChipLinks from "@/components/common/ChipLinks";
import Section from "@/components/Section";
import { useParams } from "next/navigation";

type CityLocationLinksProps = {
  data?: {
    heading: string;
    cityLocationLinks: {
      title: string;
      slug: string;
    }[];
  };
  sectionInfo: PageSections;
};

const CityLocationLinks = ({ data, sectionInfo }: CityLocationLinksProps) => {
  const { country, city } = useParams<{ country: string; city: string }>();
  if (!country) return null;
  if (city) return null;
  return (
    <Section
      id={sectionInfo.sectionId}
      className={sectionInfo.sectionClass}
      title={data?.heading}
    >
      <ChipLinks data={data?.cityLocationLinks} />
    </Section>
  );
};

export default CityLocationLinks;
